export const TIPO_FRETE = {
    FIXO: 1,
    VALOR: 2,
    KM: 3
};

export const CLAUSULA_OPERADOR = {
    MENOR_IGUAL: 1,
    MAIOR_IGUAL: 2
};

export const CONDICAO_FRETE_OPTIONS = [
    { value: 1, label: 'Até' },
    { value: 2, label: 'A partir de' }
];
